class MovingCard {
	constructor(element) {
		element.parentElement.style = `perspective: 1000px; transform-style: preserve-3d;`;

    element.addEventListener('mousemove', (event) => {
      let width = element.clientWidth;
      let height = element.clientHeight;
      let xAxis = - 15 * ((width / 2 - event.offsetX) / width);
      let yAxis = 15 * ((height / 2 - event.offsetY) / height);

      element.firstElementChild.style.transform = `rotateY(${xAxis}deg) rotateX(${yAxis}deg) translateZ(-35px)`;
    }, {passive: true});

    element.addEventListener('mouseleave', e => {
      element.firstElementChild.style.transform = `rotateY(0deg) rotateX(0deg)`;
    }, {passive: true});
	}
}
export default MovingCard;